<template>
  <div class="communities-page">
    <PageBanner
      title="Associated Builders"
      subtitle="Explore the premium residential and commercial projects in Tricity"
    />

    <BuildersGrid />

    <CtaSection
      title="Don't see your area?"
      buttonText="Contact Vipan Today"
      buttonLink="/about"
    >
      Vipan provides expert services across many more Chandigarh and Mohali
      neighborhoods. Contact us to see how we can help in your specific
      location.
    </CtaSection>
  </div>
</template>

<script setup>
import PageBanner from '@/components/PageBanner.vue';
import BuildersGrid from '@/components/BuildersGrid.vue';
import CtaSection from '@/components/CtaSection.vue';
</script>

<style scoped>
.communities-page {
  background-color: #f9f9f9;
  overflow-x: hidden;
}
</style>
